import { createSelector } from 'reselect';
import * as RequestStatus from '../actions/constants/RequestStatus';
import { isAppAuthSelector } from './AuthSelectors';
import { fetchProductInventoryStatus } from './ProductInventorySelectors';
import { fetchProductsStatus } from './ProductsSelectors';
import { fetchPurchaseMotionStatus } from './PurchaseMotionSelectors';
// This selector replicates what the above selector does, but with the addition of
// checking if the purchase options are loading. This is because we are migrating the state
// management system from redux to global context. We will do this iteratively, and can only
// remove these selector once all API calls are moved to the global context.
export const hasPricingAndPurchasingSucceededSelector = (state, {
  isPurchaseOptionsLoading
}) => {
  const isInApp = isAppAuthSelector(state);
  const productsStatus = fetchProductsStatus(state);
  const ownershipStatus = fetchProductInventoryStatus(state);
  const ownershipComplete = ownershipStatus === RequestStatus.SUCCEEDED || ownershipStatus === RequestStatus.FAILED || !isInApp;
  return productsStatus === RequestStatus.SUCCEEDED && ownershipComplete && !isPurchaseOptionsLoading;
};
export const isAppReadySelector = ({
  isPurchaseOptionsLoading
}) => createSelector([state => {
  if (isPurchaseOptionsLoading) {
    return hasPricingAndPurchasingSucceededSelector(state, {
      isPurchaseOptionsLoading
    });
  }
  return hasPricingAndPurchasingSucceededSelector(state, {
    isPurchaseOptionsLoading: false
  });
}], isAppReady => isAppReady);
export const hasOwnershipStatusSucceededSelector = state => {
  return fetchProductInventoryStatus(state) === RequestStatus.SUCCEEDED;
};
export const hasProductStatusFailedSelector = state => {
  const productsStatus = fetchProductsStatus(state);
  return productsStatus === RequestStatus.FAILED;
};
export const hasOwnershipStatusFailedSelector = state => {
  const ownershipStatus = fetchProductInventoryStatus(state);
  return ownershipStatus === RequestStatus.FAILED;
};
export const hasProductsSucceededSelector = state => {
  const productsStatus = fetchProductsStatus(state);
  return productsStatus === RequestStatus.SUCCEEDED;
};
export const hasPurchaseMotionsSucceededSelector = state => {
  const purchaseMotionStatus = fetchPurchaseMotionStatus(state);
  return purchaseMotionStatus === RequestStatus.SUCCEEDED;
};
export const hasPurchaseMotionsFailedSelector = state => {
  const purchaseMotionStatus = fetchPurchaseMotionStatus(state);
  return purchaseMotionStatus === RequestStatus.FAILED;
};
export const hasPricingAndPurchasingFailedSelector = state => {
  return hasProductStatusFailedSelector(state) || hasOwnershipStatusFailedSelector(state);
};